import * as React from 'react';
import { forwardRef } from 'react';

var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var SvgWarningIcon = function SvgWarningIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 66,
    viewBox: "0 0 78 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4087 4.44229C37.5663 2.45778 40.4337 2.45778 41.5913 4.44229L74.8682 61.4884C76.0349 63.4884 74.5923 66 72.2769 66H5.72311C3.40774 66 1.96513 63.4884 3.13177 61.4884L36.4087 4.44229Z",
    fill: "#FFD62B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2039 21C41.7632 21 42.2137 21.4587 42.2038 22.0178L41.7593 46.9596C41.7496 47.5048 41.3048 47.9418 40.7594 47.9418H37.6091C37.0637 47.9418 36.6189 47.5048 36.6092 46.9596L36.1648 22.0178C36.1548 21.4586 36.6053 21 37.1646 21H41.2039ZM39.1935 59.169C38.1717 59.169 37.2977 58.812 36.5713 58.098C35.845 57.3717 35.488 56.4976 35.5003 55.4759C35.488 54.4664 35.845 53.6046 36.5713 52.8906C37.2977 52.1643 38.1717 51.8011 39.1935 51.8011C40.1906 51.8011 41.0524 52.1643 41.7787 52.8906C42.505 53.6046 42.8744 54.4664 42.8867 55.4759C42.8744 56.1529 42.6959 56.7746 42.3512 57.3409C42.0188 57.8949 41.5756 58.3381 41.0216 58.6705C40.4676 59.0028 39.8583 59.169 39.1935 59.169Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningIcon);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=WarningIcon.svg.js.map
